export const container = `w-full text-xs`;
export const list = `flex gap-2 flex-wrap items-center justify-start`;
export const item = `py-0.5 px-1 min-w-8 text-center rounded bg-[var(--transit-route-color)] text-[var(--transit-route-text-color)]`;
